// Map D365 modules and issue categories to expert agent feature names
// Feature names match Settings.tsx FEATURE_AGENTS and getAgentForFeature()

const MODULE_TO_EXPERT: Record<string, string> = {
  'General Ledger': 'finance_expert',
  'Accounts Payable': 'finance_expert',
  'Accounts Receivable': 'finance_expert',
  'Cash and Bank Management': 'finance_expert',
  'Fixed Assets': 'finance_expert',
  'Budgeting': 'finance_expert',
  'Cost Accounting': 'finance_expert',
  'Inventory Management': 'scm_expert',
  'Warehouse Management': 'scm_expert',
  'Transportation Management': 'scm_expert',
  'Procurement': 'scm_expert',
  'Production Control': 'scm_expert',
  'Master Planning': 'scm_expert',
  'Product Information Management': 'scm_expert',
  'Sales and Marketing': 'finance_expert',
  'Project Management': 'finance_expert',
  'Human Resources': 'finance_expert',
  'Payroll': 'finance_expert',
  'Retail / Commerce': 'scm_expert',
  'Organization Administration': 'configuration_expert',
  'System Administration': 'infrastructure_expert',
}

const CATEGORY_TO_EXPERT: Record<string, string> = {
  configuration: 'configuration_expert',
  integration: 'integration_expert',
  data: 'data_migration_expert',
  performance: 'technical_expert',
}

const EXPERT_TO_DOMAIN: Record<string, string> = {
  finance_expert: 'functional',
  scm_expert: 'functional',
  technical_expert: 'technical',
  infrastructure_expert: 'infrastructure',
  integration_expert: 'integration',
  data_migration_expert: 'data',
  security_expert: 'security',
  configuration_expert: 'configuration',
}

const EXPERT_LABELS: Record<string, string> = {
  finance_expert: 'Finance Expert',
  scm_expert: 'Supply Chain Expert',
  technical_expert: 'Technical Expert',
  infrastructure_expert: 'Infrastructure Expert',
  integration_expert: 'Integration Expert',
  data_migration_expert: 'Data Migration Expert',
  security_expert: 'Security Expert',
  configuration_expert: 'Configuration Expert',
}

export function getExpertFeatureForIssue(
  d365Module: string | null,
  category: string | null,
): string {
  // Category override takes priority for cross-cutting concerns
  if (category && CATEGORY_TO_EXPERT[category]) {
    return CATEGORY_TO_EXPERT[category]
  }
  // Module-based assignment
  if (d365Module && MODULE_TO_EXPERT[d365Module]) {
    return MODULE_TO_EXPERT[d365Module]
  }
  return 'technical_expert'
}

export function getExpertiseDomain(expertFeature: string): string {
  return EXPERT_TO_DOMAIN[expertFeature] || 'functional'
}

export function getExpertLabel(expertFeature: string): string {
  return EXPERT_LABELS[expertFeature] || 'Domain Expert'
}
